import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function Header(props) {
  const config = useThemeConfig();
  const ThemedHeader = config.components.Header;
  return <ThemedHeader {...props} />;
}
